import SectionHeader from '../ui/SectionHeader';
import AnimatedCard from '../ui/AnimatedCard';
import MotionReveal from '../ui/MotionReveal';
import { education, sectionCopy } from '../../data/portfolioData';

const Education = () => {
  const copy = sectionCopy.education;

  return (
    <section id="education" className="section-padding bg-ant-bg-2 text-ant-fg border-t border-ant-line-soft">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          label={copy.label}
          titleLine1={copy.titleLine1}
          titleLine2={copy.titleLine2}
          subtitle={copy.subtitle}
        />

        <div className="grid md:grid-cols-2 gap-5">
          {education.map((item, index) => (
            <MotionReveal key={item.id} delay={index * 100}>
              <AnimatedCard className="rounded-2xl border border-white/[0.08] bg-white/[0.02] p-7 h-full hover:border-white/[0.14]">
                <div className="flex items-start justify-between gap-4 mb-5">
                  <div>
                    <h3 className="text-base font-semibold text-white">{item.degree}</h3>
                    <p className="text-sm text-ant-gold/80 mt-1">{item.school}</p>
                  </div>
                  {item.period === 'Present' && (
                    <span className="shrink-0 px-2.5 py-1 rounded-full border border-ant-gold/30 bg-ant-gold/10 font-mono text-[10px] tracking-wider text-ant-gold">
                      CURRENT
                    </span>
                  )}
                </div>
                <div className="flex flex-wrap gap-3 text-[11px] font-mono text-white/30">
                  <span>{item.period}</span>
                  <span className="text-white/15">·</span>
                  <span>{item.location}</span>
                </div>
              </AnimatedCard>
            </MotionReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;